import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ICONS } from '../session/index';

@Component({
    selector: 'app-fabbuttongroup',
    templateUrl: 'fabbuttongroup.component.html'
})

export class FabButtonGroupComponent implements OnInit {
    @Output() onClickButtonGroup: EventEmitter<any> = new EventEmitter();
    @Input() buttonGroup: any;
    classCantFb: string;
    indMoreButton: boolean;
    iconMoreButton: string;
    disabled: boolean = false;

    constructor() { }

    ngOnInit() {
        this.classCantFb = "fab-section fab" + (this.buttonGroup.length);
        this.indMoreButton = this.buttonGroup.length > 0 ? true : false;
        this.iconMoreButton = ICONS.more;
    }

    onClickFabButton(event: any) {
        this.onClickButtonGroup.emit(event);
    }

    onMouseEnter() {
        this.iconMoreButton = this.buttonGroup[this.buttonGroup.length - 1].icon;
    }

    onMouseLeave() {
        this.iconMoreButton = ICONS.more;
    }
}